export const dataJobRunTrackerConstants = {
  GET_ALL_JOB_RUN_TRACKER_REQUEST: "GET_ALL_JOB_RUN_TRACKER_REQUEST",
  GET_ALL_JOB_RUN_TRACKER_SUCCESS: "GET_ALL_JOB_RUN_TRACKER_SUCCESS",
  GET_ALL_JOB_RUN_TRACKER_FAILURE: "GET_ALL_JOB_RUN_TRACKER_FAILURE",

  GET_JOB_RUN_TRACKER_BY_ID_REQUEST: "GET_JOB_RUN_TRACKER_BY_ID_REQUEST",
  GET_JOB_RUN_TRACKER_BY_ID_SUCCESS: "GET_JOB_RUN_TRACKER_BY_ID_SUCCESS",
  GET_JOB_RUN_TRACKER_BY_ID_FAILURE: "GET_JOB_RUN_TRACKER_BY_ID_FAILURE",

  GET_DATA_QUALITY_CHECKS_REQUEST: "GET_DATA_QUALITY_CHECKS_REQUEST",
  GET_DATA_QUALITY_CHECKS_SUCCESS: "GET_DATA_QUALITY_CHECKS_SUCCESS",
  GET_DATA_QUALITY_CHECKS_FAILURE: "GET_DATA_QUALITY_CHECKS_FAILURE",

  GET_DATA_QUALITY_CHECKS_FILTER_REQUEST:
    "GET_DATA_QUALITY_CHECKS_FILTER_REQUEST",
  GET_DATA_QUALITY_CHECKS_FILTER_SUCCESS:
    "GET_DATA_QUALITY_CHECKS_FILTER_SUCCESS",
  GET_DATA_QUALITY_CHECKS_FILTER_FAILURE:
    "GET_DATA_QUALITY_CHECKS_FILTER_FAILURE",
};
